module.exports = __webpack_public_path__ + "img/favourite.9b636faa.png";